import { render, staticRenderFns } from "./StokAdetleri.vue?vue&type=template&id=326dd848&"
import script from "./StokAdetleri.vue?vue&type=script&lang=js&"
export * from "./StokAdetleri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports